/* KFG Premium v2: Schritt-Karten markieren + Header-Preis-CTA */
(function(){
  function init(){
    document.querySelectorAll('#kfg-right .kfg-step-row').forEach(function(row){
      var card = row.parentElement;
      if (card && card.id !== 'kfg-right' && !card.classList.contains('kfg-step-card')) {
        card.classList.add('kfg-step-card');
      }
    });
    var buy = document.getElementById('kfg-buy');
    if (buy && !buy.classList.contains('kfg-step-card')) {
      buy.classList.add('kfg-step-card','kfg-buy-card');
    }
    var ov = document.getElementById('kfg-overlay');
    if (ov && !document.getElementById('kfg-hdr-cta')) {
      var hdr = ov.firstElementChild;
      if (hdr && hdr.lastElementChild) {
        var w = document.createElement('div');
        w.id = 'kfg-hdr-cta';
        w.innerHTML = '<span class="p">45 €</span><button type="button">Jetzt kaufen</button>';
        w.querySelector('button').addEventListener('click', function(){
          if (window._kfgFile && typeof kfgBuyNow === 'function') { kfgBuyNow(); }
          else {
            var uz = document.getElementById('kfg-uz');
            if (uz) { uz.scrollIntoView({behavior:'smooth', block:'center'});
              uz.style.boxShadow='0 0 0 4px rgba(235,132,4,.5)';
              setTimeout(function(){ uz.style.boxShadow=''; }, 1400); }
          }
        });
        hdr.lastElementChild.replaceWith(w);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setTimeout(init, 900);
})();
